import { render, staticRenderFns } from "./tag.vue?vue&type=template&id=4f7b0b17&"
import script from "./tag.vue?vue&type=script&lang=js&"
export * from "./tag.vue?vue&type=script&lang=js&"
import style0 from "./tag.vue?vue&type=style&index=0&id=4f7b0b17&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports